import fonts from './fonts'

const textStyles = {
  titleH1: `
    ${fonts.BBCondBold}
    font-size: 3rem;
    text-transform: uppercase;
    line-height: initial;
  `,
  titleH2: `
    ${fonts.BBCond}
    font-weight: 500;
    font-size: 1.8rem;
    line-height: initial;
    text-transform: uppercase;
  `,
  titleH3: `
    ${fonts.BBCondBold}
    font-size: 1.8rem;
    line-height: initial;
    text-transform: uppercase;
  `,
  text: `
    ${fonts.BBRegular}
    font-size: 1.4rem;
    line-height: 1.5;
    letter-spacing: 0.03em;
  `,
  tiny: `
    ${fonts.BBRegular}
    font-size: 1.2rem;
    line-height: 1.5;
  `,
  // Customisation
  fieldLabel: `
    ${fonts.BBRegular}
    font-size: 1.4rem;
    line-height: normal;
    letter-spacing: 0.05em;
  `,
}

export default textStyles
